import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DiallerService } from '@app/dialler/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WorkService } from '../services';

@Component({
  selector: 'app-nailup-timeout-modal',
  templateUrl: './nailup-timeout-modal.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NailupTimeoutModalComponent {
  constructor(
    public activeModal: NgbActiveModal,
    private workSvc: WorkService,
    private diallerSvc: DiallerService
  ) {}

  break() {
    this.workSvc.showStateModal();
    this.activeModal.close();
  }

  nailup() {
    this.diallerSvc.nailInAgain();

    this.activeModal.close();
  }
}
